import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DefaultComponent } from './layouts/default-layout/default.component';
import { NotfoundComponent } from './errors/notfound/notfound.component';
import { ForbiddenComponent } from './errors/forbidden/forbidden.component';
import { PollLayoutComponent } from './layouts/poll-layout/poll-layout.component';
import { PollShowLayoutComponent } from './layouts/poll-show-layout/poll-show-layout.component';
import { DefaultModule } from './layouts/default-layout/default.module';
import { PollShowLayoutModule } from './layouts/poll-show-layout/poll-show-layout.module';
import { PollLayoutModule } from './layouts/poll-layout/poll-layout.module';


const routes: Routes = [
  { 
    path:'',
    component: DefaultComponent,
    loadChildren: () => DefaultModule,
  },
  {
    path: 'poll/:id',
    component: PollShowLayoutComponent,
    loadChildren:() => PollShowLayoutModule,
  },
  {
    path: 'mypolls',
    component: PollLayoutComponent,
    loadChildren:() => PollLayoutModule,
  },
  {
    path: 'forbidden',
    component: DefaultComponent,
    children: [
      {
        path: '',
        component: ForbiddenComponent
      }
    ]
  },
  {
    path: '**',
    component: DefaultComponent,
    children: [
      {
        path: '',
        component: NotfoundComponent
      }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
